module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-Lancaster-76018834d8f7dac75cd92fbf85b4d645.svg";